exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-fallback[data-v-dbad3e0e] {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1/1;\n    background-color: #f0f0f0;\n}\n", ""]);

// exports
